<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<label><input type="radio" :value="1" v-model="date_type_is_invoice" @change="dateTypeChanged()" />Invoice</label>
				<label><input type="radio" :value="2" v-model="date_type_is_invoice" @change="dateTypeChanged()" />Receipt</label>
				<em class="lt_text"> Date</em>
				<span class="mgr_5"> <CustomDatePicker v-model="date_from"/> ~ <CustomDatePicker v-model="date_to"/></span>
				<label class="mgr_15"><input type="checkbox" v-model="open_balance_only" /> Open Balance Only</label>
				<span class="int_type_no_border mgr_5">
					<PartnerSelect ref="billto" v-model="bill_to_code" ph="Bill To" :showName="true" :initialName="bill_to_name" :showFullName="user.company_id === 'hairplus'" :nameWidth="350" :nameClickToPopup="false" @set-partner="setPartner" />
				</span>
				<span v-if="false" class="int_type mgr_5">
					<input type="text" v-model.trim="check_no" placeholder="Enter Check No" autocomplete="off" @keyup.enter="search()" />
				</span>
				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt mgr_15" @click="reset()">Reset</a>

				<a href="javascript:void(0);" class="gray_bt mgl_15" @click="arHistoryPrint">Print</a>
				<a href="javascript:void(0);" class="gray_bt" @click="confirmCustomerStatement">Customer Statement</a>
			</div>
			<div class="left_option" style="margin-top:4px;">
				<button class="gray_bt mgr_15" @click="openModal('Memo')"><font :color="partner.memo ? 'red' : 'black'">Memo</font></button>
				<button class="gray_bt mgr_5" @click="gotoPartner(bill_to_code)"><font color="blue">Partner Detail</font></button>
				<em class="lt_text">Address </em>
				<input type="text" class="tbl_int mgr_5" style="width:300px;" :value="shipToAddressString()" readonly :title="shipToAddressString()" />
				<em class="lt_text">SalesGroup </em>
				<input type="text" class="tbl_int ssm2_int mgr_5" :value="partner.sales_group_name" readonly />
				<em class="lt_text">Salesman </em>
				<input type="text" class="tbl_int ssm2_int mgr_5" :value="partner.salesman_name" readonly />
				<em class="lt_text">Phone </em>
				<input type="text" class="tbl_int ssm2_int mgr_5" :value="partner.telephone ? partner.telephone : partner.telephone2" readonly />
				<em class="lt_text">Fax </em>
				<input type="text" class="tbl_int sm_int mgr_5" :value="partner.fax" readonly />
				<em class="lt_text">Email </em>
				<input type="text" class="tbl_int mm_int" :value="partner.email" readonly />
			</div>
			<div class="left_option" style="margin-top:4px;">
				<em class="lt_text"><font color="red">Notice</font></em>
				<input type="text" class="tbl_int lm_int" style="color:red;" v-model="partner.notice" />
				<a href="javascript:;" class="gray_bt2" @click="updateNotice()">Update</a>
			</div>
		</div>

		<div class="half_tbl_box">
			<div class="left_big4_tbl" :style="user.company_id == 'newjigu' ? 'height:1090px;' : ''">
				<div class="fixed-table-container mgb_10" :style="user.company_id == 'newjigu' ? 'height:1020px;' : ''">
					<div class="table-wrapper">
						<table id="item_list" class="list_tbl tbl_pointer" border="0">
							<thead>
								<tr>
									<th style="text-align:center;width:80px;"><div class="th-text">Inv. Date</div></th>
									<th style="text-align:center;width:105px;"><div class="th-text">Inv. No</div></th>
									<th style="text-align:center;width:130px;"><div class="th-text">AR Memo</div></th>
									<th style="text-align:center;width:45px;"><div class="th-text">UPD</div></th>
									<th style="text-align:center;width:90px;"><div class="th-text">Pay Term</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Inv. Amt.</div></th>
									<th style="text-align:center;width:80px;" v-if="show_due_days"><div class="th-text">Due Date</div></th>
									<th style="text-align:center;width:50px;" v-if="show_due_days"><div class="th-text">Day1</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Balance</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">Post Check</div></th>
									<th style="text-align:center;width:80px;"><div class="th-text">R. / P. Date</div></th>
									<th style="text-align:center;width:50px;" v-if="show_due_days"><div class="th-text">Day2</div></th>
									<th style="text-align:center;width:90px;"><div class="th-text">Amount</div></th>
									<th style="text-align:center;width:110px;"><div class="th-text">Check No</div></th>
									<th style="text-align:center;width:100px;"><div class="th-text">Receipt Remark</div></th>
									<th style="text-align:center;width:45px;"><div class="th-text">UPD</div></th>
									<th style="text-align:center;">
										<div class="th-text"><span v-if="company_id === 'hairplus'">Ship To</span><span v-else>Address</span></div>
									</th>
								</tr>
							</thead>

							<tbody>
								<tr v-if="invoices.length > 26">
									<td colspan="5" class="al_right">
										<font color="red">Total</font>
									</td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.invoice_amount | toCurrency }}</font>
									</td>
									<td colspan="2" v-if="show_due_days"></td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.balance != 0 ? invoices_sum.balance : null | toCurrency }}</font>
									</td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.post_check_amount != 0 ? invoices_sum.post_check_amount : null | toCurrency }}</font>
									</td>
									<td :colspan="show_due_days ? 2 : 1"></td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.ra_amount != 0 ? invoices_sum.ra_amount : null | toCurrency }}</font>
									</td>
									<td colspan="4">
										~30 : <font color="red">{{ aging.a_30 | toCurrency }}</font
										>, 31~60 : <font color="red">{{ aging.a30_60 | toCurrency }}</font
										>, 61~90 : <font color="red">{{ aging.a60_90 | toCurrency }}</font
										>, 91~ : <font color="red">{{ aging.a90_ | toCurrency }}</font>
									</td>
								</tr>
								<tr
									v-for="(invoice, index) in invoices"
									v-bind:key="index"
									v-bind:class="{
										on: invoice.invoice_no == selectedInvoice.invoice_no && invoice.receipt_no == selectedInvoice.receipt_no,
										same: invoice.invoice_no != selectedInvoice.invoice_no && invoice.receipt_no > 0 && invoice.receipt_no == selectedInvoice.receipt_no,
									}"
									@click="selectRow(invoice)"
								>
									<template v-if="index == 0 || (index > 0 && invoice.invoice_no != invoices[index - 1].invoice_no)">
										<td>{{ invoice.invoice_date }}</td>
										<td @click.stop="">
											<a href="javascript:;" @click="selectInvoice(invoice)">{{ invoice.invoice_dn }}</a>
										</td>
										<td @click.stop="">
											<template v-if="modifiable">
												<input type="text" class="l_int full_int" v-model.trim="invoice.ar_memo" :title="invoice.ar_memo" @focus="$event.target.select()" @click="arMemoPopup(invoice)" />
											</template>
											<template v-else>
												<span :title="invoice.ar_memo">{{ invoice.ar_memo }}</span>
											</template>
										</td>
										<td @click.stop="">
											<a v-if="modifiable" href="javascript:;" :class="invoice.ar_memo_org == invoice.ar_memo ? 'gray_bt2 disable_bt' : 'gray_bt2'" @click="updateArMemo(invoice)">UPD</a>
										</td>
										<td>{{ invoice.payment_term_name }}</td>

										<td :style="invoice.invoice_type == 'A' ? 'text-align:right;background-color:yellow' : invoice.invoice_type == 'R' ? 'text-align:right;background-color:red;color:white;' : 'text-align:right;'">
											{{ invoice.invoice_amount | toCurrency }}
										</td>
										<td v-if="show_due_days">
											<span v-if="invoice.invoice_type == 'S'">{{ invoice.due_date }}</span>
										</td>
										<td class="al_right" v-if="show_due_days">
											<span v-if="invoice.invoice_type == 'S' && (invoice.balance > 0 || invoice.post_check_amount > 0)">
												<font v-if="invoice.past_due_date > 0" style="color: red;">{{ invoice.elapsed_days | commaSeparated }}</font>
												<font v-else>{{ invoice.elapsed_days | commaSeparated }}</font>
											</span>
										</td>
										<td :style="invoice.invoice_type == 'A' ? 'text-align:right;background-color:yellow;' : invoice.invoice_type == 'R' ? 'text-align:right;background-color:red;color:white;' : 'text-align:right;'">
											<font :color="invoice.balance > 0 ? 'red' : 'black'">{{ invoice.balance | toCurrency }}</font>
										</td>
										<td style="text-align:right;">
											<font :color="invoice.post_check_amount > 0 ? 'red' : 'black'"> {{ invoice.post_check_amount ? invoice.post_check_amount : null | toCurrency }}</font>
										</td>
									</template>
									<template v-else>
										<td :colspan="show_due_days ? 10 : 8"></td>
									</template>
									<template v-if="index == 0 || (index > 0 && invoice.receipt_no != invoices[index - 1].receipt_no) || (index > 0 && invoice.invoice_no != invoices[index - 1].invoice_no)">
										<td>{{ invoice.valid_receipt_date }}</td>
									</template>
									<template v-else>
										<td></td>
									</template>
									<td class="al_right" v-if="show_due_days">
										<span v-if="invoice.day2 > 0">
											<font v-if="invoice.past_due_days2 > 0 && (invoice.balance > 0 || invoice.post_check_amount > 0)" style="color: red;">{{ invoice.day2 | commaSeparated }}</font>
											<font v-else>{{ invoice.day2 | commaSeparated }}</font>
										</span>
									</td>
									<td style="text-align:right;">
										<template v-if="invoice.invoice_count > 1 && invoice.method_count > 1">
											Not Applicable.
										</template>
										<template v-else>
											{{ invoice.ra_amount | toCurrency }}
											<span v-if="!invoice.receipt_date && invoice.ra_amount" style="color:red;">(R)</span>
											<span v-else-if="invoice.reverse_yn == 'Y'">(R)</span>
											<span v-else-if="invoice.ar_post_check && !['beautyplus', 'hairplus'].includes(company_id)" style="color:red;">(P)</span>
										</template>
									</td>
									<td class="truncate" :title="invoice.check_no">
										<template v-if="invoice.bounce_yn == 'Y'">
											<font color="red">Bounced ({{ invoice.bounce_date | moment('MM/DD') }})</font>
										</template>
										<template v-else-if="invoice.invoice_type == 'A'">{{ invoice.remark }}</template>
										<!-- <template v-else> {{ removeRCCheckNo(invoice.check_no) }}</template> -->
										<template v-else> {{ invoice.check_no }}</template>
									</td>
									<td @click.stop="">
										<template v-if="modifiable && invoice.receipt_no">
											<input type="text" class="l_int full_int" v-model.trim="invoice.receipt_remark" :title="invoice.receipt_remark" @focus="$event.target.select()" />
										</template>
										<template v-else>
											<span :title="invoice.receipt_remark">{{ invoice.receipt_remark }}</span>
										</template>
									</td>
									<td @click.stop="">
										<a v-if="modifiable && invoice.receipt_no" href="javascript:;" :class="invoice.receipt_remark_org == invoice.receipt_remark ? 'gray_bt2 disable_bt' : 'gray_bt2'" @click="updateRemark(invoice)">UPD</a>
									</td>
									<td class="truncate">
										<span v-if="company_id == 'hairplus' && invoice.bill_to_code != invoice.ship_to_code" :title="invoice.ship_to_name">{{ invoice.ship_to_code }}</span>
										<span v-else-if="invoice.address_detail != partner.address_detail" :title="invoice.ship_to_address">{{ invoice.address_detail }}</span>
									</td>
								</tr>
								<tr>
									<td colspan="5" class="al_right">
										<font color="red">Total</font>
									</td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.invoice_amount | toCurrency }}</font>
									</td>
									<td colspan="2" v-if="show_due_days"></td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.balance != 0 ? invoices_sum.balance : null | toCurrency }}</font>
									</td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.post_check_amount != 0 ? invoices_sum.post_check_amount : null | toCurrency }}</font>
									</td>
									<td :colspan="show_due_days ? 2 : 1"></td>
									<td class="al_right">
										<font color="red">{{ invoices_sum.ra_amount != 0 ? invoices_sum.ra_amount : null | toCurrency }}</font>
									</td>
									<td colspan="4">
										~30 : <font color="red">{{ aging.a_30 | toCurrency }}</font
										>, 31~60 : <font color="red">{{ aging.a30_60 | toCurrency }}</font
										>, 61~90 : <font color="red">{{ aging.a60_90 | toCurrency }}</font
										>, 91~ : <font color="red">{{ aging.a90_ | toCurrency }}</font>
									</td>
								</tr>
								<tr v-if="user.company_id == 'newjigu' && total_ar_amount != 0">
									<td colspan="5" class="al_right">
										<font color="red">Open A/R Total</font>
									</td>
									<td colspan="4" class="al_right">
										<font color="red">{{ total_ar_amount | toCurrency }}</font>
									</td>
									<td colspan="9"></td>
								</tr>
								<tr v-for="(p, index) in prepaids" v-bind:key="index">
									<td colspan="2">Prepaid SO : {{ p.so_dn }}</td>
									<td colspan="3" class="al_right">Sales Order Amount</td>
									<td class="al_right">{{ p.total_amount | toCurrency }}</td>
									<td colspan="2"></td>
									<td class="al_right">{{ p.balance | toCurrency }}</td>
									<td></td>
									<td colspan="2">{{ p.receipt_date }}</td>
									<td colspan="4"></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<div class="bottom_bt_box">
					<span class="al_left">Total Count : {{ invoices_sum.invoice_count | commaSeparated }}</span>
					<ul class="mgb_5">
						<li>
							<a href="javascript:void(0);" class="gray_bt" @click="arHistoryPrint">Print</a>
						</li>
						<li>
							<a href="javascript:void(0);" class="gray_bt" @click="confirmCustomerStatement">Customer Statement</a>
						</li>
					</ul>
					<div v-if="['newjigu'].includes(company_id)" style="clear: both;">
						<label class="right_option mgr_15"><input type="checkbox" v-model="show_credit" /> Show All Credit in Printed Customer Statement.</label>
					</div>
				</div>
			</div>

			<div class="right_small4_tbl">
				<div>
					<h4 class="inner_h5">Associated Receipts</h4>

					<table id="item_list" class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th style="text-align:center;width:18%;">R. / P. Date</th>
								<th style="text-align:center;width:25%">Receiver</th>
								<th style="text-align:center;">Check No / Info</th>
								<th style="text-align:center;width:25%;">Type</th>
								<th style="text-align:center;width:3%;">R</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="(item, i) in receiptItems" v-bind:key="item.receipt_item_no" v-bind:class="{ on: item.receipt_no == selectedReceiptItem.receipt_no }" @click="selectReceiptItem(item)">
								<td :rowspan="item.receipt_item_count > 0 ? item.receipt_item_count : 1" v-if="!i ? true : receiptItems[i - 1].receipt_dn == receiptItems[i].receipt_dn ? '' : true">{{ item.valid_receipt_date }}</td>
								<td :rowspan="item.receipt_item_count > 0 ? item.receipt_item_count : 1" v-if="!i ? true : receiptItems[i - 1].receipt_dn == receiptItems[i].receipt_dn ? '' : true">{{ item.receiver_id }}</td>
								<td class="truncate" :title="item.check_no">
									<span @click="gotoBounceList(item.receipt_dn)">
										{{ item.check_no }}<template v-if="item.bounce_yn == 'Y'"> (<font color="red">Bounced</font>)</template>
									</span>
								</td>
								<td>{{ item.receipt_type_name }}</td>
								<td :rowspan="item.receipt_item_count > 0 ? item.receipt_item_count : 1" v-if="!i ? true : receiptItems[i - 1].receipt_dn == receiptItems[i].receipt_dn ? '' : true">
									<template v-if="item.reverse_yn == 'Y'">
										<span style="font-weight:bold;color:red">&#10004;</span>
									</template>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div>
					<h4 class="inner_h5">Associated Invoices</h4>
					<table id="item_list" class="list_tbl tbl_pointer">
						<thead>
							<tr>
								<th style="text-align:center;width:14%;">Inv. No</th>
								<th style="text-align:center;width:19%;">Inv. Date</th>
								<th style="text-align:center;width:14%">Bill To</th>
								<th style="text-align:center;">Name</th>
								<th style="text-align:center;width:15%;">Inv. Amt</th>
								<th style="text-align:center;width:15%;">Paid Amt</th>
							</tr>
						</thead>

						<tbody>
							<tr v-for="invoice in receiptInvoices" v-bind:key="invoice.invoice_no">
								<td>
									<a href="javascript:;" @click="selectInvoice(invoice)">
										{{ invoice.invoice_dn }}
									</a>
								</td>
								<td>{{ invoice.invoice_date }}</td>
								<td>{{ invoice.bill_to_code }}</td>
								<td class="truncate">{{ invoice.bill_to_name }}</td>
								<td class="al_right">{{ invoice.invoice_amount | toCurrency }}</td>
								<td class="al_right">{{ invoice.amount | toCurrency }}</td>
							</tr>
							<tr>
								<td class="al_right" colspan="4"><font color="red">Total</font></td>
								<td class="al_right">
									<font color="red">{{ receiptInvoices_inv_total | toCurrency }}</font>
								</td>
								<td class="al_right">
									<font color="red">{{ receiptInvoices_paid_total | toCurrency }}</font>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<div v-if="storeCredit.sc_no > 0">
					<h4 class="inner_h5">Associated Stored Credit</h4>
					<div style="padding-left:5px;padding-bottom:5px;">
						<span style="padding-top:5px;display:inline-block;">Request Date : {{ storeCredit.request_date }}</span> <br />
						<span style="padding-top:5px;display:inline-block;"
							>Store Credit No : <a href="javascript:;" @click="gotoStoreCredit(storeCredit.sc_no)">{{ storeCredit.sc_dn }}</a></span
						>
					</div>
				</div>
			</div>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'Memo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Partner Memo</template>
			<template slot="body">
				<MemoPopup :partner_code="partner.code" v-on:close="closeModal($event)" />
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'ArMemo'">
			<!-- default 슬롯 콘텐츠 -->
			<template slot="title">Invoice AR Memo</template>
			<template slot="body">
				<div style="width:450px; height:170px;" v-on:keyup.esc="close()">
					<table class="view_tbl">
						<colgroup>
							<col style="width:70px;" />
							<col style="" />
						</colgroup>
						<tbody>
							<tr>
								<th>Invoice No</th>
								<td>
									<input type="text" v-model.trim="clicked_invoice.invoice_dn" class="tbl_int" readonly />
								</td>
							</tr>
							<tr>
								<th>Invoice AR Memo</th>
								<td>
									<textarea style="padding:2px;" rows="3" v-model.trim="new_ar_memo" class="textarea_type"></textarea>
								</td>
							</tr>
						</tbody>
					</table>

					<div class="view_bottom_bt" style="padding-top:20px;">
						<a href="javascript:;" type="button" class="search_bt" @click="saveArMemo()">Save</a>
						<a href="javascript:;" type="button" class="gray_bt" @click="closeModal()">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<CustomerStatementCriteria
			v-if="showModal && modalName == 'customer_statement_criteria'"
			@close="closeModal()"
			:show_credit="show_credit"
			:show_PDC="show_PDC"
			:show_payment="show_payment"
			:init_payment_date="payment_date"
			@change_show_credit="boolean => (show_credit = boolean)"
			@change_show_PDC="boolean => (show_PDC = boolean)"
			@change_show_payment="boolean => (show_payment = boolean)"
			@change_payment_date="date => (payment_date = date)"
			@printStatement="printCustomerStatement()"
		/>
	</div>
</template>

<script>
import { inputSelectOnClick } from '@/utils/etc.js';

import { apiSelectArHistory, apiSelectReceiptItemList, apiSelectReceiptInvoiceList, apiUpdateReceiptRemark } from '@/api/receipt/index.js';
import { apiSelectStoreCredit } from '@/api/partner/storecredit.js';
import { apiUpdateArMemo } from '@/api/sales/invoice.js';

import PartnerSelect from '@/components/common/PartnerSelect';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';

import Modal from '@/components/common/Modal';
import MemoPopup from '@/components/common/MemoPopup';
import CustomerStatementCriteria from '@/components/common/CustomerStatementCriteria.vue';
import '@/assets/css/table_box.css';
import { today, daysAgo } from '@/utils/date.js';
import { apiGetBase64ReportTemplate, companyMrtUrl, objectCopy, PrintType, Report, reportMrtUrl, reportRender, objectToFormData } from '@/api/util';
import { apiSelectCustomerStatement } from '@/api/report/report';
import { apiSelectPartner, apiUpdateNotice } from '@/api/partner/index.js';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'N',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			bill_to_code: null,
			bill_to_name: null,
			check_no: null,
			amount: null,

			date_type_is_invoice: '1',

			date_from: daysAgo(180),
			date_to: today(),

			invoices: [],
			selectedInvoice: {},

			receiptItems: [],
			selectedReceiptItem: {},

			storeCredit: {},

			receiptInvoices: [],

			receiptInvoices_inv_total: null,
			receiptInvoices_paid_total: null,

			invoices_sum: {},

			initial_invoice_no: null,

			ar_memo: null,

			partner: {},

			distinct_invoices: [],

			modalName: '',
			showModal: false,

			default_ago_days: 180,

			clicked_invoice: {},
			new_ar_memo: null,
			saveParam: '',

			show_credit: true,
			show_PDC: true,
			show_payment: false,
			payment_date: today(),

			prepaids: [],

			open_balance_only: false,

			total_ar_amount: null,
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : '';
		},
		aging() {
			var a_30 = 0;
			var a30_60 = 0;
			var a60_90 = 0;
			var a90_ = 0;
			this.distinct_invoices.forEach(i => {
				if (i.aging_date <= 30) a_30 += i.ar_amount;
				else if (i.aging_date > 30 && i.aging_date <= 60) a30_60 += i.ar_amount;
				else if (i.aging_date > 60 && i.aging_date <= 90) a60_90 += i.ar_amount;
				else if (i.aging_date > 90) a90_ += i.ar_amount;
			});

			return { a_30: a_30, a30_60: a30_60, a60_90: a60_90, a90_: a90_ };
		},
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		show_due_days() {
			return !!(this.user && this.user.company_id === 'newjigu');
		},
	},
	components: {
		Modal,
		MemoPopup,
		CustomDatePicker,
		PartnerSelect,
		CustomerStatementCriteria,
	},
	methods: {
		arMemoPopup(inv) {
			this.$alertify.prompt('AR Memo', inv.ar_memo, (evt, value) => {
				//if (value != inv.ar_memo) this.$toast.warning('Click UPD button to save');
				//inv.ar_memo = value;
				if (value != inv.ar_memo) {
					inv.ar_memo = value;
					this.updateArMemo(inv);
				}
			});
		},
		gotoPartner(code) {
			//console.log(code);
			//this.$router.push({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
			if (code) {
				let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { backUri: this.uri, code: code } });
				window.open(routeData.href, 'herp_partner');
			}
		},
		gotoBounceList(receipt_dn) {
			const to = {
				name: 'bounceList',
				query: {
					receipt_dn: receipt_dn,
					invoice_dn: this.selectedInvoice ? this.selectedInvoice.invoice_dn : null,
				},
			};
			let routeData = this.$router.resolve(to);
			window.open(routeData.href, '_blank');
		},
		gotoStoreCredit(sc_no) {
			let routeData = this.$router.resolve({ name: 'scDetail', params: { mode: 'detail' }, query: { backUri: this.uri, sc_no: sc_no } });
			window.open(routeData.href, 'herp_sc');
		},
		removeRCCheckNo(check_no) {
			var rv = '';
			if (this.company_id == 'beautyplus' && check_no) {
				var nos = check_no.split(' ');
				for (var i = 0; i < nos.length; i++) if (!nos[i].trim().startsWith('RC')) rv += nos[i] + ' ';
				return rv.trim();
			} else {
				return check_no;
			}
		},
		//사용 안함
		async saveArMemo() {
			const { data } = await apiUpdateArMemo({
				invoice_no: this.clicked_invoice.invoice_no,
				ar_memo: this.new_ar_memo,
			});

			if (data.result) {
				this.$toast.success('Updated successfully');
				this.clicked_invoice.ar_memo = this.new_ar_memo;
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}

			this.closeModal();
		},

		async updateNotice() {
			if (!this.partner || !this.partner.code) return;

			const { data } = await apiUpdateNotice(this.partner);

			if (data.result) {
				this.$toast.success('Updated successfully');
			} else {
				this.$toast.error('Failed');
			}
		},
		openArMemo(invoice) {
			this.clicked_invoice = invoice;
			this.new_ar_memo = invoice.ar_memo;
			this.openModal('ArMemo');
		},
		openModal(modalName) {
			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal(rv) {
			this.showModal = false;
			if (rv) this.search();
		},
		shipToAddressString() {
			if (this.partner && Object.keys(this.partner).length > 0) return this.partner.address_detail + ', ' + this.partner.address_city + ', ' + this.partner.address_state + ' ' + this.partner.address_zipcode + ', ' + this.partner.country;
			else return '';
		},
		async updateArMemo(invoice) {
			if (invoice.ar_memo_org == invoice.ar_memo) return;

			const { data } = await apiUpdateArMemo(invoice);

			if (data.result) {
				this.$toast.success('Updated successfully');
				invoice.ar_memo_org = invoice.ar_memo;
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}
		},
		async updateRemark(invoice) {
			if (invoice.receipt_remark_org == invoice.receipt_remark) return;

			const { data } = await apiUpdateReceiptRemark(invoice);

			if (data.result) {
				this.$toast.success('Updated successfully');
				this.invoices
					.filter(i => i.receipt_no == invoice.receipt_no)
					.forEach(i => {
						i.receipt_remark_org = invoice.receipt_remark;
						i.receipt_remark = invoice.receipt_remark;
					});
				this.$forceUpdate();
			} else {
				this.$toast.error('Failed');
			}
		},
		dateTypeChanged() {
			if (this.bill_to_code) this.search();
		},
		selectInvoice(invoice) {
			if (invoice.invoice_type == 'A') return;
			else if (invoice.invoice_type != 'B' && !invoice.invoice_dn.startsWith('BC')) {
				let routeData = this.$router.resolve({ name: 'invoiceDetail', params: { mode: 'detail' }, query: { backUri: this.uri, invoice_no: invoice.invoice_no } });
				window.open(routeData.href, '_blank');
			}
		},

		setPartner(partner) {
			this.bill_to_name = partner.name;
			this.ar_memo = partner.ar_memo;
			this.getArAmount(partner.code);
			this.search();
		},
		async getArAmount(code) {
			const { data } = await apiSelectPartner({ code: code, include_balance: true });
			this.total_ar_amount = data.partner.balance + data.partner.post_check_amount;
		},
		search() {
			this.page_no = 1;
			this.selectReceipts();
		},
		reset() {
			this.page_no = 1;
			this.bill_to_code = null;
			this.bill_to_name = null;
			this.check_no = null;
			this.amount = null;
			this.ar_memo = null;

			this.date_from = daysAgo(this.default_ago_days);
			this.date_to = today();

			this.show_credit = true;
			this.show_PDC = true;
			this.show_payment = false;
			this.payment_date = today();

			this.open_balance_only = false;

			this.$session.set('ar_history_uri', null);
		},
		async selectReceipts() {
			if (!this.bill_to_code) {
				this.$toast.error('Empty partner');
				return;
			}

			this.invoices = [];
			this.selectedInvoice = {};
			this.receiptItems = [];
			this.selectedReceiptItem = {};
			this.receiptInvoices = [];
			this.receiptInvoices_inv_total = 0;
			this.receiptInvoices_paid_total = 0;
			this.distinct_invoices = [];

			var param = {
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				bill_to_code: this.bill_to_code,
				code: this.bill_to_code,

				for_ar_history: true,
				exclude_void: true,
			};
			if (this.date_type_is_invoice == '1') {
				param.invoice_date_from = this.date_from;
				param.invoice_date_to = this.date_to;
			} else if (this.date_type_is_invoice == '2') {
				param.receipt_date_from = this.date_from;
				param.receipt_date_to = this.date_to;
			}

			if (this.open_balance_only) param.real_outstanding_yn = 'Y';
			this.saveParam = objectCopy(param);
			const { data } = await apiSelectArHistory(param);

			if (this.user.company_id == 'newjigu')
				//우선 뉴지구만 적용
				this.prepaids = data.prepaidList;

			var vm = this;
			this.invoices = data.arHistory;
			this.invoices.forEach(i => {
				i.receipt_remark_org = i.receipt_remark;
				i.ar_memo_org = i.ar_memo;
				if (vm.distinct_invoices.filter(i2 => i2.invoice_no == i.invoice_no).length == 0) vm.distinct_invoices.push({ invoice_no: i.invoice_no, aging_date: i.aging_date, ar_amount: i.balance + i.post_check_amount });
			});

			this.list_count = data.list_count;
			if (data.invoicesSum) this.invoices_sum = data.invoicesSum;
			else this.invoices_sum = {};

			if (data.partner) {
				this.partner = data.partner;
				this.ar_memo = data.partner.ar_memo;
			} else {
				this.partner = {};
			}

			var uri = '/receipt/ar_history?page_no=' + this.page_no;
			if (this.bill_to_code) uri += '&bill_to_code=' + this.bill_to_code;
			if (this.bill_to_name) uri += '&bill_to_name=' + this.bill_to_name;
			if (this.date_from) uri += '&date_from=' + this.date_from;
			if (this.date_to) uri += '&date_to=' + this.date_to;
			if (this.check_no) uri += '&check_no=' + this.check_no;
			if (this.amount) uri += '&amount=' + this.amount;
			if (this.date_type_is_invoice) uri += '&date_type_is_invoice=' + this.date_type_is_invoice;
			this.uri = uri;
			window.history.pushState({}, null, uri);
			this.$session.set('ar_history_uri', uri);

			if (this.initial_invoice_no) {
				var found = this.invoices.filter(i => i.invoice_no == this.initial_invoice_no);
				if (found.length > 0) this.selectRow(found[0]);

				this.initial_invoice_no = null;
			}

			if (this.partner.memo && this.user.company_id != 'newjigu') this.openModal('Memo');
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectReceipts();
		},
		async selectReceiptItem(item) {
			this.selectedReceiptItem = item;

			const { data } = await apiSelectReceiptInvoiceList({
				receipt_no: item.receipt_no,
			});
			this.receiptInvoices = data.receiptInvoiceList;
			this.receiptInvoices_inv_total = 0;
			this.receiptInvoices_paid_total = 0;
			this.receiptInvoices.forEach(i => {
				this.receiptInvoices_inv_total += i.invoice_amount;
				this.receiptInvoices_paid_total += i.amount;
			});
		},
		selectRow(invoice) {
			this.selectedInvoice = invoice;
			this.selectedReceiptItem = {};

			this.storeCredit = {};

			this.selectReceiptItems(invoice.invoice_no);

			if (invoice.invoice_type == 'A') this.selectStoreCredit(invoice.invoice_no);
		},
		async selectStoreCredit(invoice_no) {
			var param = {
				ar_invoice_no: invoice_no,
			};
			const { data } = await apiSelectStoreCredit(param);

			if (data.store_credit) this.storeCredit = data.store_credit;
		},
		async selectReceiptItems(invoice_no) {
			this.receiptInvoices = [];
			this.receiptInvoices_inv_total = null;
			this.receiptInvoices_paid_total = null;

			const { data } = await apiSelectReceiptItemList({
				invoice_no: invoice_no,
				including_deleted: true,
			});
			this.receiptItems = data.receiptItemList;

			if (this.receiptItems.length == 1) {
				this.selectReceiptItem(this.receiptItems[0]);
			}
		},

		agingList(arHistory) {
			let a_30 = 0;
			let a30_60 = 0;
			let a60_90 = 0;
			let a90_ = 0;

			let list = [];
			arHistory.forEach((i, index) => {
				i.show = index === 0 || (index > 0 && i.invoice_no !== arHistory[index - 1].invoice_no);
				let bool = false;
				if (!i.receipt_date && i.ra_amount) {
					bool = true;
				}
				if (i.reverse_yn === 'Y') bool = true;
				i.r = bool;
				i.receipt_remark_org = i.receipt_remark;
				i.ar_memo_org = i.ar_memo;
				if (list.filter(i2 => i2.invoice_no == i.invoice_no).length == 0) list.push({ invoice_no: i.invoice_no, aging_date: i.aging_date, ar_amount: i.balance + i.post_check_amount });
			});
			list.forEach(i => {
				if (i.aging_date <= 30) a_30 += i.ar_amount;
				else if (i.aging_date > 30 && i.aging_date <= 60) a30_60 += i.ar_amount;
				else if (i.aging_date > 60 && i.aging_date <= 90) a60_90 += i.ar_amount;
				else if (i.aging_date > 90) a90_ += i.ar_amount;
			});

			return { a_30: a_30, a30_60: a30_60, a60_90: a60_90, a90_: a90_ };
		},

		async arHistoryPrint() {
			const { data } = await apiSelectArHistory(this.saveParam);

			data.aging = this.agingList(data.arHistory);

			await reportRender(data, 'ArHistory', reportMrtUrl('ArHistory'));
		},

		async confirmCustomerStatement() {
			if (!this.bill_to_code) {
				this.$toast.error('Please Select Customer First.');
				return;
			}

			if (['minkhair'].includes(this.company_id)) {
				this.modalName = 'customer_statement_criteria';
				this.showModal = true;
			} else {
				this.printCustomerStatement();
			}
		},
		async printCustomerStatement() {
			const param = objectToFormData({
				partner_codes: [this.partner.code],
				comparison_target: 'bill_to_code',
				date: today(),
				payment_date: this.payment_date,
				show_credit: this.show_credit,
				show_PDC: this.show_PDC,
				show_payment: this.show_payment,
			});
			const { data } = await apiSelectCustomerStatement(param);

			const reportTemplate = await apiGetBase64ReportTemplate('customerStatement', companyMrtUrl('customerStatement'));
			let ccList = [];
			if (data.data.length === 1) {
				if (data.data[0].customer.email) ccList.push(data.data[0].customer.email);
			}
			const report = new Report(reportTemplate, data, this.partner.code, PrintType.Normal, false, false, ccList);
			this.$store.commit('setReport', report);
		},
	},
	created() {
		this.$store.commit('setSideIndex', 5);
		this.$store.commit('setSelectedMenu', 'nav_li_ar_history');
		this.$store.commit('setSubTitle', 'Accounting -> AR History');

		if (this.$route.query.bill_to_code) this.bill_to_code = this.$route.query.bill_to_code;
		if (this.$route.query.bill_to_name) this.bill_to_name = this.$route.query.bill_to_name;
		if (this.$route.query.date_from) this.date_from = this.$route.query.date_from;
		if (this.$route.query.date_to) this.date_to = this.$route.query.date_to;
		if (this.$route.query.check_no) this.check_no = this.$route.query.check_no;
		if (this.$route.query.amount) this.amount = this.$route.query.amount;
		if (this.$route.query.date_type_is_invoice) this.date_type_is_invoice = this.$route.query.date_type_is_invoice;
		if (this.$route.query.invoice_no) this.initial_invoice_no = this.$route.query.invoice_no;

		if (this.$route.query.all_date) {
			this.date_from = null;
			this.date_to = null;
		} else {
			if (this.company_id == 'hairplus') this.default_ago_days = 548;
			else this.default_ago_days = 180;

			this.date_from = daysAgo(this.default_ago_days);
		}

		if (this.bill_to_code) {
			this.getArAmount(this.bill_to_code);
			this.selectReceipts();
		}
	},
	mounted() {
		inputSelectOnClick();

		this.$nextTick(function() {
			if (!this.bill_to_code) this.$refs.billto.$el.children[0].focus();
		});
	},
};
</script>

<style></style>
